import React, { FC, ReactNode } from 'react';
import { Box, Stack, useTheme } from '@mui/material';

import { height as headerHeight } from '@/theme/components/MuiAppBar';
import Header from '@/views/Header/Header';
import Navbar from '@/views/Navbar/Navbar';

const EXTRA_PADDING = 10;

interface AppLayoutProps {
  children: ReactNode;
}

const AppLayout: FC<AppLayoutProps> = ({ children }) => {
  const { spacing } = useTheme();

  return (
    <>
      <Stack direction="row" height="100%" textAlign="center">
        <Header />
        <Navbar />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: 'grey.50',
            mt: spacing(headerHeight),
            height: `calc(100dvh - ${spacing(headerHeight)} - ${EXTRA_PADDING})`
          }}
        >
          {children}
        </Box>
      </Stack>
    </>
  );
};

export default AppLayout;
